import React, {useContext} from 'react';
import {useTranslation} from 'react-i18next';
import * as R from 'ramda';

import {Card, CardBody} from 'reactstrap';
import Separator from '@/views/shared/Separator';
import {cmsSetting} from '@/config';
import {SystemConfigCtx} from '@/contexts';
import MainSiteLink from '@/components/MainSiteLink';
import * as supportLink from '@/contexts/support-link';
import styles from '@/views/Activation/index.module.css';
import {blank} from '@/util';

const RegWithoutEmail = () => {
  const {t: tr, i18n: i18nCtx} = useTranslation('activation');
  const subtr = tr('without_email');

  const form = R.path(['form', 'changeContactDetails'], cmsSetting);
  const inquiryEmail = R.path(['inquiry', 'email'], cmsSetting);
  const jaInquiryEmail = R.path(['inquiry', 'jaEmail'], cmsSetting);
  const {siteCode} = useContext(SystemConfigCtx);

  if (blank(siteCode)) {
    return null;
  }

  const NonJaContent = () => (
    <>
      <span>
        {subtr.content_line1}
        <br />
        {subtr.content_line2}
        <a href={form} target='_blank' rel='noopener noreferrer'>
          {subtr.content_form_name}{' '}
        </a>{' '}
        {subtr.content_line3}{' '}
        <a
          href={`mailto:${inquiryEmail}`}
          target='_blank'
          rel='noopener noreferrer'
        >
          {`${inquiryEmail}`}
        </a>
      </span>
      <br />
      <br />
      <span>
        {subtr.content_line4}{' '}
        <MainSiteLink
          href={supportLink.contactUs(siteCode)}
          target='_blank'
          rel='noopener noreferrer'
        >
          {subtr.content_line5}
        </MainSiteLink>
      </span>
    </>
  );

  const JaContent = () => (
    <span>
      {subtr.content_line1}{' '}
      <a
        href={`mailto:${jaInquiryEmail}`}
        target='_blank'
        rel='noopener noreferrer'
      >
        {`${jaInquiryEmail}`}
      </a>
      <br />
      {subtr.content_line2}
    </span>
  );

  return (
    <Card>
      <CardBody className={styles.section}>
        <div className='text-center'>
          <br />
          <h1 className={styles.title}>{tr('online_reg_title')}</h1>
          <Separator />
          <h3 className={styles.subtitle}>{subtr.sub_title}</h3>
          {i18nCtx.language === 'ja' && <JaContent />}
          {i18nCtx.language !== 'ja' && <NonJaContent />}
        </div>
      </CardBody>
    </Card>
  );
};

export default RegWithoutEmail;
